import { render } from "./UserInput.vue?vue&type=template&id=c87a79c8&scoped=true"
import script from "./UserInput.vue?vue&type=script&lang=js"
export * from "./UserInput.vue?vue&type=script&lang=js"

import "./UserInput.vue?vue&type=style&index=0&id=c87a79c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c87a79c8"]])

export default __exports__